<template>
  <v-card v-if="missingItems.length" class="alert-card mb-4" rounded="lg" style="border-left: 6px solid #a86400">
    <v-card-text class="pa-5">
      <v-row align="center">
        <v-col cols="12" md="8">
          <div class="d-flex align-start mb-2">
            <v-icon size="32" color="warning darken-1" class="mr-3">mdi-account-alert-outline</v-icon>
            <div>
              <h2 class="text-subtitle-1 font-weight-bold">ข้อมูลติดต่อยังไม่สมบูรณ์</h2>
              <ul class="text-caption grey--text mb-0 pl-4">
                <li v-for="msg in missingItems" :key="msg">{{ msg }}</li>
              </ul>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="4" class="text-md-right text-center">
          <v-btn color="warning" outlined @click="$emit('edit')">
            <v-icon left small>mdi-pencil</v-icon>
            แก้ไขข้อมูล
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "ProfileCompletenessAlert",
  props: {
    users: { type: Object, required: true }
  },
  computed: {
    missingItems() {
      const items = [];
      if (!this.users.tel_p) items.push("ยังไม่ได้กรอกเบอร์โทรศัพท์");
      if (!this.users.e_mail) {
        items.push("ยังไม่ได้กรอกอีเมล");
      } else if (!/^[^\s@]+@gmail\.com$/i.test(this.users.e_mail)) {
        items.push("อีเมลควรเป็น @gmail.com เพื่อรับการแจ้งเตือนจากระบบ");
      }
      return items;
    }
  }
};
</script>

<style scoped>
.alert-card {
  transition: box-shadow 0.2s ease;
}
</style>
